module.exports = __webpack_public_path__ + "static/img/himalayas.e09948a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/himalayas.jpg
// module id = 15Rg
// module chunks = 1